<div *ngFor="let image of expandImages; let i = index">
  <div class="accordion card">
    <div class="card-header" (click)="toggleCollapsed(i)">
      <a [ngClass]="getActiveStyle(i)">{{ image.title }}</a>
    </div>
    <div [ngClass]="getAccordionStyle(i)" class="card-body">
      <img src="{{ image.image }}" alt="" width="100%" />
    </div>
  </div>
  <div [innerHTML]="image.description | mdToHtml"></div>
</div>

<div *ngFor="let accordianSection of accordianSections; let i = index">
  <div class="accordion card">
    <div class="card-header" (click)="toggleCollapsed(i)">
      <a [ngClass]="getActiveStyle(i)">{{ accordianSection.title }}</a>
    </div>
    <div [ngClass]="getAccordionStyle(i)" class="card-body">
      <div [innerHTML]="accordianSection.body | mdToHtml"></div>
    </div>
  </div>
  <div [innerHTML]="accordianSection.subBody! | mdToHtml"></div>
</div>
